/**
 * External packages
 */
import Vue from 'vue';
import Base from './base';
import axios from 'axios';
import Routes from './routes/routes';
import VueRouter from 'vue-router';
import moment from 'moment-timezone';
import InfiniteLoading from 'vue-infinite-loading';
import ElementUI from 'element-ui';
import CKEditor from '@ckeditor/ckeditor5-vue';
import 'element-ui/lib/theme-chalk/index.css';

/**
 * Register packages
 */
Vue.use(ElementUI);
Vue.use(InfiniteLoading);
Vue.use(CKEditor);

/**
 * Some necessary packages
 */
window._ = require('lodash');
window.Popper = require('popper.js').default;
require('bootstrap');

/**
 * Axios parameters
 */
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.baseURL = (process.env.NODE_ENV !== 'production')
    ? '/api/'
    : '/api/';

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

Vue.axios = axios;

/**
 * Default timezone
 */
window.moment = moment;
window.moment.tz.setDefault(app.timezone);

/**
 * Router
 */
Vue.use(VueRouter);
const router = new VueRouter({
    routes: Routes,
    mode: 'history',
    base: '/',
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);

    next();
})

Vue.router = router;

/**
 * Authentication
 */
import VueAuth from '@websanova/vue-auth';
import Auth from './auth';
Vue.use(VueAuth, Auth);

Vue.auth.permissions = function (permission) {
    return this.options.check.call(this, permission, 'abilities');
};

/**
 * Clipboard
 */
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

/**
 * Global components
 */
import './components-fields';
import './components-basic';

/**
 * Mixins
 */
Vue.mixin(Base);

window.Bus = new Vue();

/**
 * Create vue instance
 */
import App from './components/App';

new Vue({
    el: '#app',
    router,
    render: h => h(App)
});
